import React from 'react';
import { colorToString } from '../utils';

import './HeatmapLegend.scss';
const LegendSegment = (props) => {
  return (
    <div
      className="cviz-heatmap-legend-segment"
      style={{
        backgroundColor: colorToString(props.color),
        borderColor: colorToString(props.color),
      }}
    >
      <div className="cviz-heatmap-legend-cell">
        {props.desc.toLocaleString()}
      </div>
    </div>
  );
};

export default LegendSegment;
